import ParameterSetting from "presentation/components/Parameter/ParameterForm";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import React, { useRef } from "react";
import RoleManagement from "./RoleManagement";
import { Permission } from "domain/entities/permission";
import PermissionManagement from "./PermissionManagement";

const UserPanel: React.FC = () => {
  const toast = useRef<Toast>(null);
  return (
    <div>
      <div className="card">
        <TabView>
          <TabPanel header="Funções" leftIcon="pi pi-calendar-clock mr-2">
            <RoleManagement />
          </TabPanel>
          <TabPanel header="Permissões" leftIcon="pi pi-list mr-2">
            <PermissionManagement />
          </TabPanel>
        </TabView>
        <div className="next-button"></div>
        <Toast ref={toast} position="bottom-right" />
      </div>
    </div>
  );
};

export default UserPanel;
